import axios from "axios";

const find = async (find = null, select = null) => {
    return await axios.get('/time', { params: { find: { ...find }, select: select } } );
};

const findById = async (id) => {
    return await axios.get('/time/' + id);
};

const create = async (data) => {
    return await axios.post('/time', data);
};

const update = async (id, data) => {
    return await axios.put('/time/' + id, data);
};

const remove = async (id) => {
    return await axios.delete('/time/' + id);
};

const TimeService = {
    find,
    findById,
    create,
    update,
    remove
}

export default TimeService;